import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/caprock/status/active.svg'
import _imports_1 from '../assets/caprock/status/pending.svg'
import _imports_2 from '../assets/caprock/status/archive.svg'
import _imports_3 from '../assets/caprock/status/reject.svg'
import _imports_4 from '../assets/caprock/status/suspend.svg'


const _withScopeId = n => (_pushScopeId("data-v-e049cf86"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "main-content",
  style: {"overflow-y":"none"}
}
const _hoisted_2 = { class: "section" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "tab-content w-100" }
const _hoisted_5 = {
  class: "row m-0 bg-card-light",
  style: {"border-radius":"10px 10px 0px 0px"}
}
const _hoisted_6 = { class: "col-md-4 d-flex justify-content-start py-4" }
const _hoisted_7 = { class: "d-flex" }
const _hoisted_8 = {
  class: "font-size-16 font-grey p-cursor",
  onclick: "location.href='https://map.admin.caprock.com.au/edit-customer/54?type=view'"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"height":"35px","margin":"0 15px"},
  src: "https://map.admin.caprock.com.au/inlancer-admin/images/users-sqr.svg"
}, null, -1))
const _hoisted_10 = {
  key: 0,
  style: {"color":"#6B7A99"}
}
const _hoisted_11 = {
  key: 1,
  style: {"color":"#6B7A99"}
}
const _hoisted_12 = { class: "col-md-6 d-flex justify-content-center align-items-center py-4" }
const _hoisted_13 = { class: "nav justify-content-center" }
const _hoisted_14 = { class: "nav-item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { class: "font-grey active" }, "Profile", -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "nav-item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { class: "font-grey" }, "External Banks", -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { class: "font-grey" }, "Managing Members", -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = {
  key: 1,
  class: "nav-item"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { class: "font-grey" }, "Beneficial Owners", -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = { class: "nav-item" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { class: "font-grey" }, "Accounts", -1))
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-2 d-flex justify-content-end align-items-center py-4" }, null, -1))
const _hoisted_30 = {
  class: "tab-pane fade show active",
  id: "pills-profile",
  role: "tabpanel",
  "aria-labelledby": "pills-currency-tab"
}
const _hoisted_31 = { class: "row mb-5 pb-5 justify-content-center" }
const _hoisted_32 = { class: "col-md-3 mt-4" }
const _hoisted_33 = { class: "p-3 mb-4 bg-card-light border-radius-10 d-block text-center h-100" }
const _hoisted_34 = ["src"]
const _hoisted_35 = { class: "font-grey font-size-14 mt-3" }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { key: 1 }
const _hoisted_38 = { class: "font-grey font-size-12 mt-3" }
const _hoisted_39 = {
  key: 0,
  src: _imports_0,
  style: {"height":"1rem","margin-right":"5px","margin-top":"-2px"}
}
const _hoisted_40 = {
  key: 1,
  src: _imports_1,
  style: {"height":"1rem","margin-right":"5px","margin-top":"-2px"}
}
const _hoisted_41 = {
  key: 2,
  src: _imports_2,
  style: {"height":"1rem","margin-right":"5px","margin-top":"-2px"}
}
const _hoisted_42 = {
  key: 3,
  src: _imports_3,
  style: {"height":"1rem","margin-right":"5px","margin-top":"-2px"}
}
const _hoisted_43 = {
  key: 4,
  src: _imports_4,
  style: {"height":"1rem","margin-right":"5px","margin-top":"-2px"}
}
const _hoisted_44 = { class: "font-grey font-size-12 mt-3" }
const _hoisted_45 = { class: "col-md-8 mt-4" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "hidden",
  name: "_token",
  value: "WuuHK4uzjwGdpFzhDA6PhsUV4469KagHWvi7oeBB"
}, null, -1))
const _hoisted_47 = { class: "p-4 mb-4 bg-card-light border-radius-10 h-100" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-flex justify-content-between" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "font-grey font-size-14" }, [
    /*#__PURE__*/_createElementVNode("b", null, "Profile")
  ])
], -1))
const _hoisted_49 = { class: "row my-3 mx-1" }
const _hoisted_50 = { class: "col-md-4" }
const _hoisted_51 = { class: "form-group" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey mx-2" }, "Status", -1))
const _hoisted_53 = { class: "ml-2 p_label" }
const _hoisted_54 = { class: "col-md-4" }
const _hoisted_55 = { class: "form-group" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey mx-2" }, "First Name", -1))
const _hoisted_57 = { class: "ml-2 p_label" }
const _hoisted_58 = { class: "col-md-4" }
const _hoisted_59 = { class: "form-group" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey mx-2" }, "Last Name", -1))
const _hoisted_61 = { class: "ml-2 p_label" }
const _hoisted_62 = { class: "col-md-4" }
const _hoisted_63 = { class: "form-group" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey mx-2" }, "Phone", -1))
const _hoisted_65 = { class: "ml-2 p_label" }
const _hoisted_66 = { class: "col-md-4" }
const _hoisted_67 = { class: "form-group" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey mx-2" }, "Type", -1))
const _hoisted_69 = { class: "ml-2 p_label" }
const _hoisted_70 = { class: "col-md-6" }
const _hoisted_71 = { class: "form-group" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey mx-2" }, "Email", -1))
const _hoisted_73 = { class: "ml-2 p_label" }
const _hoisted_74 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_75 = { class: "form-group" }
const _hoisted_76 = {
  class: "font-grey mx-2",
  style: {"display":"block"}
}
const _hoisted_77 = {
  width: "12pt",
  height: "12pt",
  "inkscape:version": "0.92.3 (2405546, 2018-03-11)",
  "sodipodi:docname": "edit.svg",
  version: "1.1",
  viewBox: "0 0 752 752",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:inkscape": "http://www.inkscape.org/namespaces/inkscape",
  "xmlns:sodipodi": "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
}
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", { transform: "matrix(2.4108 0 0 2.4108 -530.47 -530.46)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#899AAA",
    d: "m468.4 229.19c-14.43-0.043-28.277 5.6875-38.457 15.914l-98.598 98.645c-16.949 16.84-26.449 39.762-26.379 63.648v39.641h39.641-4e-3c23.875 0.0547 46.777-9.4453 63.602-26.379l98.695-98.602c10.199-10.207 15.922-24.047 15.918-38.477-8e-3 -14.426-5.7422-28.262-15.949-38.461-10.203-10.199-24.043-15.93-38.469-15.93zm18.375 72.742-98.602 98.648c-11.527 11.594-27.219 18.09-43.57 18.043h-11.223v-11.227c-0.0352-16.332 6.4609-32.004 18.043-43.52l98.648-98.648c6.6289-6.2148 16.027-8.5195 24.781-6.0703 8.7539 2.4453 15.594 9.2852 18.039 18.039 2.4492 8.7539 0.14453 18.152-6.0703 24.781z",
    "inkscape:connector-curvature": "0"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#899AAA",
    d: "m281.29 522.81h170.49c13.816 0 27.066-5.4883 36.836-15.258 9.7695-9.7695 15.258-23.02 15.258-36.836v-75.773h-28.414v75.773c0 6.2773-2.4961 12.301-6.9336 16.742-4.4414 4.4414-10.465 6.9375-16.746 6.9375h-170.49c-6.2812 0-12.305-2.4961-16.742-6.9375-4.4414-4.4414-6.9375-10.465-6.9375-16.742v-170.49c0-6.2773 2.4961-12.301 6.9375-16.742 4.4375-4.4414 10.461-6.9336 16.742-6.9336h75.773v-28.418h-75.773c-13.816 0-27.066 5.4883-36.836 15.258s-15.258 23.023-15.258 36.836v170.49c0 13.816 5.4883 27.066 15.258 36.836 9.7695 9.7695 23.02 15.258 36.836 15.258z",
    "inkscape:connector-curvature": "0"
  })
], -1))
const _hoisted_79 = { class: "ml-2 p_label" }
const _hoisted_80 = { class: "col-md-3 mt-4" }
const _hoisted_81 = { class: "py-5 px-4 bg-card-light border-radius-10 d-block text-left h-100" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-around align-items-center" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "font-grey font-size-16" }, " Accounts Analytics ")
], -1))
const _hoisted_83 = { class: "d-block text-center mt-5" }
const _hoisted_84 = { class: "font-grey font-size-18 mt-3" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "font-grey font-size-12 mt-4" }, " Portfolio ", -1))
const _hoisted_86 = { class: "d-block text-center mt-5" }
const _hoisted_87 = { class: "font-grey font-size-18 mt-3" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "font-grey font-size-12 mt-4" }, " Accounts ", -1))
const _hoisted_89 = { class: "d-block text-center mt-5" }
const _hoisted_90 = { class: "font-grey font-size-18 mt-3" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "font-grey font-size-12 mt-4" }, " Deposit ", -1))
const _hoisted_92 = { class: "d-block text-center mt-5" }
const _hoisted_93 = { class: "font-grey font-size-18 mt-3" }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "font-grey font-size-12 mt-4" }, " Withdrawal ", -1))
const _hoisted_95 = { class: "col-md-8 mt-4" }
const _hoisted_96 = {
  key: 0,
  class: "p-4 mb-4 bg-card-light border-radius-10",
  id: "CompanyDiv"
}
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-flex justify-content-between" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "font-grey font-size-14" }, [
    /*#__PURE__*/_createElementVNode("b", null, "Company Details")
  ])
], -1))
const _hoisted_98 = { class: "row my-3 mx-1" }
const _hoisted_99 = { class: "col-md-6" }
const _hoisted_100 = { class: "form-group" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey mx-2" }, "Company Name", -1))
const _hoisted_102 = { class: "ml-2 p_label" }
const _hoisted_103 = { class: "col-md-6" }
const _hoisted_104 = { class: "form-group" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey mx-2" }, "Company Address", -1))
const _hoisted_106 = { class: "ml-2 p_label" }
const _hoisted_107 = { class: "p-4 mb-4 bg-card-light border-radius-10" }
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-flex justify-content-between" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "font-grey font-size-14" }, [
    /*#__PURE__*/_createElementVNode("b", null, "Location")
  ])
], -1))
const _hoisted_109 = { class: "row my-3 mx-1" }
const _hoisted_110 = { class: "col-md-4" }
const _hoisted_111 = { class: "form-group" }
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey mx-2" }, "Country", -1))
const _hoisted_113 = { class: "ml-2 p_label" }
const _hoisted_114 = { class: "col-md-4" }
const _hoisted_115 = { class: "form-group" }
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey mx-2" }, "State", -1))
const _hoisted_117 = { class: "ml-2 p_label" }
const _hoisted_118 = { class: "col-md-4" }
const _hoisted_119 = { class: "form-group" }
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey mx-2" }, "City", -1))
const _hoisted_121 = { class: "ml-2 p_label" }
const _hoisted_122 = { class: "col-md-4" }
const _hoisted_123 = { class: "form-group" }
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey mx-2" }, "Zip Code", -1))
const _hoisted_125 = { class: "ml-2 p_label" }
const _hoisted_126 = { class: "col-md-8" }
const _hoisted_127 = { class: "form-group" }
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey mx-2" }, "Address", -1))
const _hoisted_129 = { class: "ml-2 p_label" }
const _hoisted_130 = {
  class: "modal fade",
  id: "change_password",
  tabindex: "-1",
  "aria-labelledby": "changePasswordLabel",
  "aria-hidden": "true"
}
const _hoisted_131 = { class: "modal-dialog" }
const _hoisted_132 = { class: "modal-content" }
const _hoisted_133 = {
  class: "modal-header",
  style: {"padding":"0.4rem 0.5rem","background":"#005288"}
}
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", {
  class: "font-size-16 font-white p-cursor",
  id: "changePasswordLabel"
}, "Change Password", -1))
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "25",
  height: "25",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M18.5932 11.3926L11.4053 18.5806",
    stroke: "#fff",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M18.5954 18.5847L11.4014 11.3892",
    stroke: "#fff",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M21.5017 1.125H8.49823C3.96673 1.125 1.12573 4.3335 1.12573 8.874V21.126C1.12573 25.6665 3.95323 28.875 8.49823 28.875H21.5002C26.0467 28.875 28.8757 25.6665 28.8757 21.126V8.874C28.8757 4.3335 26.0467 1.125 21.5017 1.125Z",
    stroke: "#fff",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_136 = [
  _hoisted_135
]
const _hoisted_137 = { class: "modal-body" }
const _hoisted_138 = { class: "card p-4 mb-1 bg-card-light border-radius-10 h-100" }
const _hoisted_139 = { style: {"color":"red"} }
const _hoisted_140 = { style: {"color":"green"} }
const _hoisted_141 = { class: "row my-3 mx-1" }
const _hoisted_142 = { class: "col-md-12" }
const _hoisted_143 = { class: "form-group" }
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey mx-2" }, "New Password", -1))
const _hoisted_145 = { class: "col-md-12" }
const _hoisted_146 = { class: "form-group" }
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey mx-2" }, "Confirm Password", -1))
const _hoisted_148 = { class: "col-md-12 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_basic = _resolveComponent("basic")!
  const _component_right_side = _resolveComponent("right-side")!
  const _component_sodipodi58namedview = _resolveComponent("sodipodi:namedview")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_basic),
    _createVNode(_component_right_side, {
      user_info: _ctx.user_info,
      customer_accounts: _ctx.customer_accounts
    }, null, 8, ["user_info", "customer_accounts"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, [
                  _createElementVNode("h5", _hoisted_8, [
                    _hoisted_9,
                    (_ctx.user_info.u_type!=2)
                      ? (_openBlock(), _createElementBlock("b", _hoisted_10, _toDisplayString(_ctx.user_info.user_name), 1))
                      : _createCommentVNode("", true),
                    (_ctx.user_info.u_type==2)
                      ? (_openBlock(), _createElementBlock("b", _hoisted_11, _toDisplayString(_ctx.user_info.user_company_name), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("ul", _hoisted_13, [
                  _createElementVNode("li", _hoisted_14, [
                    _createElementVNode("a", {
                      class: "nav-link",
                      "aria-current": "page",
                      href: "javascript:;",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/my-profile')))
                    }, _hoisted_16)
                  ]),
                  _createElementVNode("li", _hoisted_17, [
                    _createElementVNode("a", {
                      class: "nav-link",
                      "aria-current": "page",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/bank-accounts'))),
                      href: "javascript:;"
                    }, _hoisted_19)
                  ]),
                  (_ctx.user_info.is_directors==1)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_20, [
                        _createElementVNode("a", {
                          class: "nav-link",
                          "aria-current": "page",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/managing-members'))),
                          href: "javascript:;"
                        }, _hoisted_22)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.user_info.is_owners==1)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_23, [
                        _createElementVNode("a", {
                          class: "nav-link",
                          "aria-current": "page",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/beneficial-owners'))),
                          href: "javascript:;"
                        }, _hoisted_25)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("li", _hoisted_26, [
                    _createElementVNode("a", {
                      class: "nav-link",
                      href: "javascript:;",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push('/my-accounts')))
                    }, _hoisted_28)
                  ])
                ])
              ]),
              _hoisted_29
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("img", {
                      id: "viewProfilePic",
                      onError: _cache[5] || (_cache[5] = ($event: any) => (_ctx.loadImage())),
                      src: _ctx.profile_url,
                      style: {"width":"100px","height":"100px","object-fit":"cover","border-radius":"50%","margin":"30px auto"}
                    }, null, 40, _hoisted_34),
                    _createElementVNode("h5", _hoisted_35, [
                      (_ctx.user_info.u_type!=2)
                        ? (_openBlock(), _createElementBlock("b", _hoisted_36, _toDisplayString(_ctx.user_info.user_name), 1))
                        : _createCommentVNode("", true),
                      (_ctx.user_info.u_type==2)
                        ? (_openBlock(), _createElementBlock("b", _hoisted_37, _toDisplayString(_ctx.user_info.user_company_name), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("h5", _hoisted_38, [
                      (_ctx.user_info.user_status==1)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_39))
                        : _createCommentVNode("", true),
                      (_ctx.user_info.user_status==3)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_40))
                        : _createCommentVNode("", true),
                      (_ctx.user_info.user_status==2)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_41))
                        : _createCommentVNode("", true),
                      (_ctx.user_info.user_status==4)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_42))
                        : _createCommentVNode("", true),
                      (_ctx.user_info.user_status==0)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_43))
                        : _createCommentVNode("", true),
                      _createTextVNode(" Client No : " + _toDisplayString(_ctx.user_info.client_no), 1)
                    ]),
                    _createElementVNode("h5", _hoisted_44, _toDisplayString(_ctx.user_info.type), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _hoisted_46,
                  _createElementVNode("div", _hoisted_47, [
                    _hoisted_48,
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("div", _hoisted_50, [
                        _createElementVNode("div", _hoisted_51, [
                          _hoisted_52,
                          _createElementVNode("p", _hoisted_53, _toDisplayString(_ctx.user_info.status), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_54, [
                        _createElementVNode("div", _hoisted_55, [
                          _hoisted_56,
                          _createElementVNode("p", _hoisted_57, _toDisplayString(_ctx.user_info.user_first_name), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_58, [
                        _createElementVNode("div", _hoisted_59, [
                          _hoisted_60,
                          _createElementVNode("p", _hoisted_61, _toDisplayString(_ctx.user_info.user_last_name), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_62, [
                        _createElementVNode("div", _hoisted_63, [
                          _hoisted_64,
                          _createElementVNode("p", _hoisted_65, _toDisplayString(_ctx.user_info.user_phone_no), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_66, [
                        _createElementVNode("div", _hoisted_67, [
                          _hoisted_68,
                          _createElementVNode("p", _hoisted_69, _toDisplayString(_ctx.user_info.type), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_70, [
                        _createElementVNode("div", _hoisted_71, [
                          _hoisted_72,
                          _createElementVNode("p", _hoisted_73, _toDisplayString(_ctx.user_info.user_email), 1)
                        ])
                      ]),
                      (_ctx.user_info.u_type!=2)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                            _createElementVNode("div", _hoisted_75, [
                              _createElementVNode("label", _hoisted_76, [
                                _createTextVNode(" Password "),
                                _createElementVNode("span", {
                                  onClick: _cache[6] || (_cache[6] = ($event: any) => {this.openModal('change_password');}),
                                  title: "Change Password",
                                  class: "ml-2 dropdown-toggle dropdownMenuButton",
                                  id: "dropdownMenuButton",
                                  role: "button",
                                  "data-bs-toggle": "dropdown",
                                  "aria-haspopup": "true",
                                  "aria-expanded": "false"
                                }, [
                                  (_openBlock(), _createElementBlock("svg", _hoisted_77, [
                                    _createVNode(_component_sodipodi58namedview, {
                                      bordercolor: "#666666",
                                      borderopacity: "1",
                                      gridtolerance: "10",
                                      guidetolerance: "10",
                                      "inkscape:current-layer": "svg8",
                                      "inkscape:cx": "501.33333",
                                      "inkscape:cy": "501.33333",
                                      "inkscape:pageopacity": "0",
                                      "inkscape:pageshadow": "2",
                                      "inkscape:window-height": "667",
                                      "inkscape:window-maximized": "1",
                                      "inkscape:window-width": "1366",
                                      "inkscape:window-x": "0",
                                      "inkscape:window-y": "27",
                                      "inkscape:zoom": "0.23537234",
                                      objecttolerance: "10",
                                      pagecolor: "#ffffff",
                                      showgrid: "false"
                                    }),
                                    _hoisted_78
                                  ]))
                                ])
                              ]),
                              _createElementVNode("p", _hoisted_79, _toDisplayString(_ctx.user_info.password), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_80, [
                  _createElementVNode("div", _hoisted_81, [
                    _hoisted_82,
                    _createElementVNode("div", _hoisted_83, [
                      _createElementVNode("h5", _hoisted_84, [
                        _createElementVNode("b", null, _toDisplayString(_ctx.d_currency_icon) + " " + _toDisplayString(_ctx.portfolio.toLocaleString(undefined,{minimumFractionDigits:2,maximumFractionDigits:2})), 1)
                      ]),
                      _hoisted_85
                    ]),
                    _createElementVNode("div", _hoisted_86, [
                      _createElementVNode("h5", _hoisted_87, [
                        _createElementVNode("b", null, _toDisplayString(_ctx.accounts), 1)
                      ]),
                      _hoisted_88
                    ]),
                    _createElementVNode("div", _hoisted_89, [
                      _createElementVNode("h5", _hoisted_90, [
                        _createElementVNode("b", null, _toDisplayString(_ctx.d_currency_icon) + " " + _toDisplayString(_ctx.deposit.toLocaleString(undefined,{minimumFractionDigits:2,maximumFractionDigits:2})), 1)
                      ]),
                      _hoisted_91
                    ]),
                    _createElementVNode("div", _hoisted_92, [
                      _createElementVNode("h5", _hoisted_93, [
                        _createElementVNode("b", null, _toDisplayString(_ctx.d_currency_icon) + " " + _toDisplayString(_ctx.withdrawal.toLocaleString(undefined,{minimumFractionDigits:2,maximumFractionDigits:2})), 1)
                      ]),
                      _hoisted_94
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_95, [
                  (_ctx.user_info.type=='Corporate')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                        _hoisted_97,
                        _createElementVNode("div", _hoisted_98, [
                          _createElementVNode("div", _hoisted_99, [
                            _createElementVNode("div", _hoisted_100, [
                              _hoisted_101,
                              _createElementVNode("p", _hoisted_102, _toDisplayString(_ctx.user_info.user_company_name), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_103, [
                            _createElementVNode("div", _hoisted_104, [
                              _hoisted_105,
                              _createElementVNode("p", _hoisted_106, _toDisplayString(_ctx.user_info.user_company_address), 1)
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_107, [
                    _hoisted_108,
                    _createElementVNode("div", _hoisted_109, [
                      _createElementVNode("div", _hoisted_110, [
                        _createElementVNode("div", _hoisted_111, [
                          _hoisted_112,
                          _createElementVNode("p", _hoisted_113, _toDisplayString(_ctx.user_info.country), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_114, [
                        _createElementVNode("div", _hoisted_115, [
                          _hoisted_116,
                          _createElementVNode("p", _hoisted_117, _toDisplayString(_ctx.user_info.state), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_118, [
                        _createElementVNode("div", _hoisted_119, [
                          _hoisted_120,
                          _createElementVNode("p", _hoisted_121, _toDisplayString(_ctx.user_info.city), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_122, [
                        _createElementVNode("div", _hoisted_123, [
                          _hoisted_124,
                          _createElementVNode("p", _hoisted_125, _toDisplayString(_ctx.user_info.user_zip), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_126, [
                        _createElementVNode("div", _hoisted_127, [
                          _hoisted_128,
                          _createElementVNode("p", _hoisted_129, _toDisplayString(_ctx.user_info.user_google_address), 1)
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_130, [
      _createElementVNode("div", _hoisted_131, [
        _createElementVNode("div", _hoisted_132, [
          _createElementVNode("div", _hoisted_133, [
            _hoisted_134,
            _createElementVNode("span", {
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.closeModal('change_password'))),
              style: {"cursor":"pointer"}
            }, _hoisted_136)
          ]),
          _createElementVNode("div", _hoisted_137, [
            _createElementVNode("div", _hoisted_138, [
              _createElementVNode("p", _hoisted_139, _toDisplayString(_ctx.erorr), 1),
              _createElementVNode("p", _hoisted_140, _toDisplayString(_ctx.success), 1),
              _createElementVNode("div", _hoisted_141, [
                _createElementVNode("div", _hoisted_142, [
                  _createElementVNode("div", _hoisted_143, [
                    _hoisted_144,
                    _withDirectives(_createElementVNode("input", {
                      onKeyup: _cache[8] || (_cache[8] = ($event: any) => {this.erorr='';}),
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.new_password) = $event)),
                      type: "password",
                      name: "new_password",
                      class: "typeMode passfield fo rm-control"
                    }, null, 544), [
                      [_vModelText, _ctx.new_password]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_145, [
                  _createElementVNode("div", _hoisted_146, [
                    _hoisted_147,
                    _withDirectives(_createElementVNode("input", {
                      onKeyup: _cache[10] || (_cache[10] = ($event: any) => {this.erorr='';}),
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.confirm_password) = $event)),
                      type: "password",
                      name: "confirm_password",
                      class: "typeMode passfield for m-control"
                    }, null, 544), [
                      [_vModelText, _ctx.confirm_password]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_148, [
                  _createElementVNode("button", {
                    onClick: _cache[12] || (_cache[12] = ($event: any) => {_ctx.change_password();}),
                    type: "button",
                    class: "btn btn-orange font-white rounded-pill",
                    style: {"padding":"6px 40px","text-align":"center"}
                  }, _toDisplayString(_ctx.pwd_label), 1)
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}